import { createFileRoute, Outlet } from '@tanstack/react-router';
import { TIME_OFF_TABS, type TimeOffTab } from '@/pages/Time/time-off-tabs';
import { parseScopeParam, type ScopeParam } from '@/pages/Time/acting-tenant';

/**
 * Segment layout for `/time/off` — the parent of the request create/edit routes.
 * Gating lives on the `/time` segment; per-tab visibility is handled inside the shell.
 *
 * `?tab=` keeps a known tab (the shell picks the landing tab by permission otherwise) and `?scope=` is the agency client scope
 * of the Leave policies and Holiday calendars tabs (LPH-T35 FR-11): `own`, `all` or a client tenant id, anything else `own`.
 * Both optional, so a bare `/time/off` link stays valid; every other key is returned untouched.
 */
export const Route = createFileRoute('/time/off')({
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & { tab?: TimeOffTab; scope?: ScopeParam } => ({
    ...search,
    tab: (TIME_OFF_TABS as readonly unknown[]).includes(search.tab) ? (search.tab as TimeOffTab) : undefined,
    scope: search.scope === undefined ? undefined : parseScopeParam(search.scope),
  }),
  component: Outlet,
});
